// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F9I4","content":"styles_content__fiAcY","row":"styles_row__244-C","footer":"styles_footer__26ZS0","phraseLength":"styles_phraseLength__3jnh5"};